var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Outline-v2",
    d: "M74.5,49.61A13.51,13.51,0,1,0,61.23,33.86H16v4.5H61.23A13.49,13.49,0,0,0,74.5,49.61Zm0-22.51a9,9,0,1,1-9,9A9,9,0,0,1,74.5,27.1ZM29.71,49.4A13.5,13.5,0,1,0,43,65.22H88v-4.5H43A13.49,13.49,0,0,0,29.71,49.4Zm0,22.5a9,9,0,1,1,9-9A9,9,0,0,1,29.71,71.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggle);
export default __webpack_public_path__ + "static/media/toggle.99c479dab9743294dd1ec625556c540c.svg";
export { ForwardRef as ReactComponent };